import { differenceInHours } from 'date-fns'

import { IChart, IChartLookup, IChartRow } from 'shared/interfaces'

export const rankCharts = (charts: IChart[], labelId: string): IChartRow[] => {
  const rows: IChartRow[] = []

  charts
    .reduce((chartResult: IChart[], chart: IChart, idx, arr) => {
      const duplicateInCurrentLabel = arr.find(
        (item) =>
          item.artist === chart.artist &&
          item.title === chart.title &&
          item.configuration === chart.configuration &&
          item.label_id !== chart.label_id &&
          item.label_id === labelId &&
          item.rank === chart.rank
      )

      if (chart.label_id !== labelId && duplicateInCurrentLabel) {
        return chartResult
      }

      return [
        ...chartResult,
        {
          ...chart,
          campaign_id: chart.label_id && chart.label_id !== labelId ? null : chart.campaign_id
        }
      ]
    }, [])
    .forEach((chart) => {
      let position: any = rows.find((item) => item.rank === chart.rank)

      if (!position) {
        position = { rank: chart.rank, entries: [chart] }
        rows.push(position)
      } else {
        position.entries.push(chart)
      }
    })

  return rows.filter((row) => row.entries.length)
}

export const findEntryOfSource = (entries: IChart[], factSource: IChartLookup): IChart | undefined => {
  return entries.find((entry) => entry.chart === factSource.chart && entry.configuration === factSource.configuration)
}

export const isOutdated = (factDate: string, cycle: string): boolean => {
  const chartAge: number = differenceInHours(Date.now(), Date.parse(factDate))

  // Set the allowed age in hours of charts until we show them as outdated.
  // Big leeway to accommodate different daily charts
  // TODO: Differentiate better between yesterdays charts coming today and todays charts coming today
  const dailyOutDatedThreshold = 72 // 3 days
  const weeklyOutDatedThreshold = 168 // 7 days

  return cycle === 'weekly' ? chartAge >= weeklyOutDatedThreshold : chartAge >= dailyOutDatedThreshold
}
